import React$1 from 'react';

const Download = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M17.5 11.5v2H.5v-2h17zM15.5.086L16.914 1.5 8.5 9.914.086 1.5 1.5.086l7 6.999 7-7z"
}));

export default Download;
